<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'管理员配置',goback:true},{name:'添加管理员'}]" :title="'添加管理员'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                
                    <div class="child">
                        <div class="name"><span>*</span>姓名：</div>
                        <el-input v-model="sendInfoTwo.dto.realName" maxlength="20"></el-input>
                    </div>
					<div class="error" v-if="errors['sendInfoTwo.dto.realName']">错误提示：{{errors['sendInfoTwo.dto.realName']}}</div>

      <div class="child">
                        <div class="name"><span v-if="!id">*</span>账号：</div>
                        <el-input v-model="sendInfoTwo.dto.userName" maxlength="20" v-if="!id"></el-input>
                        <div class="content" v-else>{{sendInfoTwo.dto.userName}}</div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.dto.userName'] && !id">错误提示：{{errors['sendInfoTwo.dto.userName']}}</div>
                    <div class="child">
                        <div class="name">初始密码：</div>
                        <div class="content">账号初始密码与账号相同，请管理员尽快修改密码</div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>管理员类型：</div>
                        <div class="content">
                        <el-radio-group v-model="sendInfoTwo.dto.administratorType" @change="radioChange">
                            <el-radio :label="item.value" v-for="(item,index) in administratorTypeList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.dto.administratorType']">错误提示：{{errors['sendInfoTwo.dto.administratorType']}}</div>
                    <div class="child" v-show="sendInfoTwo.dto.administratorType=='SYSTEM_ADMINISTRATOR'" style="align-items:flex-start">
                        <div class="name">绑定角色：</div>
                        <div class="content">
                        <el-transfer v-model="sendInfoTwo.dto.roleIds" :data="transferList" :titles="['未选', '已选']" :props="{key: 'id',label: 'roleName'}"></el-transfer>
                        </div>
                    </div>
                     <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="doubleBtn">
                          <el-button size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import upLoad from '../../components/upLoad';
import wangEditor from 'wangeditor';
import wangEnduit from '../../components/wangEnduit';
export default {
    components:{
        breadcrumb,
        upLoadFiles,upLoad,wangEnduit
    },
    data(){
        return{
            id:void 0,
            sendInfoTwo:{
                id:null,//修改用户id
                dto:{
                    administratorType:null,//管理员类型
                    realName:null,//姓名
                    roleIds:[],//id数组
                    userName:null,//账号
                }
            },//编辑提交数据
            transferList:[],//穿梭框数据
            administratorTypeList:[],//管理员类型数组
            editor:null,//富文本编辑器容器
            editType:1
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.dto.realName':'realName',
        'sendInfoTwo.dto.userName':'userName',
        'sendInfoTwo.dto.administratorType':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择管理员类型'
        },
    },
    methods:{
      //单选切换获取穿梭框数组
        radioChange:function(val){
            if(val=='SYSTEM_ADMINISTRATOR'){ //系统管理员 穿梭框
                this.$axiosz.get('backstage/administrator/echo',{params:{id:this.sendInfoTwo.id}}).then((r)=>{
                    if(r.code==200){
                        if(r.data.selectRoles && r.data.selectRoles.length>0){
                            this.transferList=[...r.data.notSelectRoles,...r.data.selectRoles];
                        }else{
                            this.transferList=[...r.data.notSelectRoles];
                        }
                        if(r.data.selectRoles && r.data.selectRoles.length>0){
                            for(let item of r.data.selectRoles){
                                this.sendInfoTwo.dto.roleIds.push(item.id);
                            }
                        }
                    }else{
                        this.$alert(r.msg)
                    }
                })
            }
        },
      //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/ADMINISTRATOR_TYPE').then((r)=>{ //管理员类型
                if(r.code==200){
                    this.administratorTypeList=r.data;
                }
            })
        },
		onEditorChange(val){
		  // let _html=val.container.innerHTML;
		  this.sendInfo.content=val;
		},
		getDetail(id){
			this.$axiosz.get('backstage/administrator/echo',{params:{id}}).then((r)=>{
			    if(r.code==200){
                        this.sendInfoTwo.dto.realName=r.data.realName;
                        this.sendInfoTwo.dto.userName=r.data.userName;
                        this.sendInfoTwo.dto.administratorType=r.data.administratorType;
                        this.transferList=[...r.data.notSelectRoles,...r.data.selectRoles];
                        if(r.data.selectRoles){
                            for(let item of r.data.selectRoles){
                                this.sendInfoTwo.dto.roleIds.push(item.id);
                            }
                        }
                    }else{
                        this.$alert(r.msg)
                    }
			})
		},
        cancel(){
          this.$router.back(-1)
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                if(this.editType==1){ //新增
                    this.$axiosz.get('backstage/administrator/userName/'+this.sendInfoTwo.dto.userName).then((r)=>{
                        if(r.code==200){
                            this.$axiosz({
                                method: 'post',
                                url: 'backstage/administrator',
                                data: this.sendInfoTwo.dto,
                                headers: { 'content-type': 'application/json;charset=UTF-8' },
                            }).then((r)=>{
                                if(r.code==200){
                                    this.$message({
                                        type: 'success',
                                        message: '添加成功!'
                                    });
                                    this.cancel();
                                }else{
                                    this.$alert(r.msg)
                                }
                            })
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }else{ //编辑
                    this.$axiosz({
                        method: 'put',
                        url: 'backstage/administrator/'+this.sendInfoTwo.id,
                        data: this.sendInfoTwo.dto,
                        headers: { 'content-type': 'application/json;charset=UTF-8' },
                    }).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            this.cancel();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }
            }   
        },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
    const {id} = this.$route.params
    this.id= id || void 0
    this.getDic();
		if(id){
        this.editType = 2
		    this.sendInfoTwo.id=id;
			  this.getDetail(id);
		}else this.editType = 1
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>
